import {Paper, TableBody, Table, TableCell, TableContainer, TableRow, Typography} from "@mui/material";
import {QuerySummaryTableHeaders} from "../../pages/QueryPage/components/QuerySummaryTable/components/QuerySummaryTableHeaders";

export const NoDataFoundTable = () => {

    return (
        <TableContainer
            component={Paper}
            style={{
                maxWidth: '96%',
                marginLeft: 'auto',
                marginRight: 'auto',
                marginTop: '4px'
            }}
        >
            <Table>
                <TableBody>
                    <TableRow>
                        <TableCell colSpan={12}>
                            <Typography
                                variant="caption"
                                component="p"
                                align="center"
                                style={{color: 'grey'}}
                            >
                                No Data Found
                            </Typography>
                        </TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </TableContainer>
    )
}